
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leadPages",
      function () {
        return require("private-next-pages/leadPages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leadPages"])
      });
    }
  